import { SITEGLUE_MARKETING_ORIGIN } from "~/lib/auth-paths";

/** Marketing-domain confirmation page for Google Ads URL conversions. */
export const SITEGLUE_HIRE_CONVERSION_PATH = "/welcome";

const ALLOWED_CONTINUE_HOSTS = new Set([
  "app.easygpt.builders",
  "staging.easygpt.builders",
  "localhost",
  "127.0.0.1",
]);

/** Absolute SiteGlue welcome URL that then continues to the app settings path. */
export function buildSiteGlueHireConversionUrl(continueAppPath: string): string {
  const path = continueAppPath.startsWith("/") ? continueAppPath : `/${continueAppPath}`;
  const continueUrl = new URL(path, "https://app.easygpt.builders");
  const welcome = new URL(SITEGLUE_HIRE_CONVERSION_PATH, SITEGLUE_MARKETING_ORIGIN);
  welcome.searchParams.set("hired", "1");
  welcome.searchParams.set("continue", continueUrl.toString());
  return welcome.toString();
}

/** Only allow continue redirects to EasyGPT app hosts (open-redirect safe). */
export function sanitizeHireConversionContinueUrl(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  try {
    const url = new URL(raw.trim());
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    const host = url.hostname.toLowerCase();
    if (!ALLOWED_CONTINUE_HOSTS.has(host) && !host.endsWith(".easygpt.builders")) {
      return null;
    }
    if (!url.pathname.startsWith("/projects/")) return null;
    return url.toString();
  } catch {
    return null;
  }
}
